export default __webpack_public_path__ + "static/media/TJSymbol.afe2b2ca.svg";